"use client"
import { Doctor } from "@/types"
import { DoctorCard } from "./doctor-card"

interface DoctorListProps {
  doctors: Doctor[];
  onEdit: (doctor: Doctor) => void;
  onDelete: (id: string) => void;
}

export function DoctorList({ doctors, onEdit, onDelete }: DoctorListProps) {
  if (doctors.length === 0) {
    return (
      <div className="text-center py-10 text-muted-foreground">
        No doctors found. Add your first doctor to get started.
      </div>
    )
  }

  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
      {doctors.map((doctor) => (
        <DoctorCard key={doctor.id} doctor={doctor} onEdit={() => onEdit(doctor)} onDelete={() => onDelete(doctor.id)} />
      ))}
    </div>
  )
} 